import { useFormContext } from "react-hook-form";
import { OTP_VERIFY_VALIDATOR } from "../../../const/validators.ts";
import Input from "../../core/Input.tsx";
import { ErrorMessage } from "@hookform/error-message";
import { IconMail } from "@tabler/icons-react";

const ConfirmInput = ({ requiredText }: { requiredText: string }) => {
  const {
    register,
    formState: { errors, touchedFields },
  } = useFormContext();

  return (
    <Input
      input="input"
      label={"Verifizierungscode"}
      validatorHint={<ErrorMessage errors={errors} name="otp" />}
      icon={<IconMail stroke={2} />}
      isTouched={!!touchedFields.otp}
      isError={!!errors.otp}
    >
      <input
        inputMode="numeric"
        autoComplete="one-time-code"
        placeholder="235813"
        maxLength={6}
        {...register("otp", {
          required: requiredText,
          validate: OTP_VERIFY_VALIDATOR,
        })}
      />
    </Input>
  );
};
export default ConfirmInput;
